import { render, staticRenderFns } from "./DateIsWeekend.vue?vue&type=template&id=63973b2c&scoped=true"
import script from "./DateIsWeekend.vue?vue&type=script&lang=js"
export * from "./DateIsWeekend.vue?vue&type=script&lang=js"
import style0 from "./DateIsWeekend.vue?vue&type=style&index=0&id=63973b2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63973b2c",
  null
  
)

export default component.exports